import React from 'react'
import {Radio} from '~/src/design-system/BaseComponents'
import {useField} from 'formik'
import styled from 'styled-components'

const RadioGroupRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--space-4);
  align-items: center;
`

const ErrorText = styled.span`
  color: var(--error-main, #ff6760);
  font-size: 0.75rem;
  margin-top: var(--space-1);
`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function FormikYesNo({name, ...otherProps}: any) {
  const [field, meta, helpers] = useField(name)

  return (
    <div data-testid={`formik-yes-no-${name}`}>
      <RadioGroupRow data-testid={`formik-yes-no-radio-group-${name}`}>
        <Radio
          name={name}
          value="true"
          checked={field.value === true}
          onChange={() => helpers.setValue(true)}
          label="Yes"
          data-testid={`formik-yes-no-yes-${name}`}
        />
        <Radio
          name={name}
          value="false"
          checked={field.value === false}
          onChange={() => helpers.setValue(false)}
          label="No"
          data-testid={`formik-yes-no-no-${name}`}
        />
      </RadioGroupRow>
      {meta.touched && meta.error && (
        <ErrorText data-testid={`formik-yes-no-helper-${name}`}>{meta.error}</ErrorText>
      )}
    </div>
  )
}
